import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';
import DocumentUploadForm from './DocumentUploadForm';
import FontAwesome from 'react-fontawesome';
import { withTranslation, Trans } from 'react-i18next';

class QuestionnaireUpload extends Component {
	render() {
		const { t, questionnaireFormUrl, onSubmit } = this.props;

		return <Alert bsStyle='warning'>
			{t('FO_IndividualConsultation_QuestionnaireDescription')}
			<div><a target='blank' href={questionnaireFormUrl}><strong>{t('FO_IndividualConsultation_QuestionnaireDownload')}</strong></a></div>
			<p>
				<Trans i18nKey='FO_IndividualConsultation_QuestionnaireWarning'>
					<strong>Important!</strong> Once you upload the questionnaire back to the system, you cannot make further changes.
				</Trans>
			</p>
			<div>
				<DocumentUploadForm
					initialValues={{ type: 'IndividualConsultationQuestionnaire' }}
					onSubmit={onSubmit}
					fileLabel={t('FO_IndividualConsultation_QuestionnaireFile')}
					submitLabel={<span>{t('FO_IndividualConsultation_QuestionnaireUpload')} <FontAwesome name='arrow-circle-right' /></span>}
				/>
			</div>
		</Alert>;
	}
}

export default withTranslation()(QuestionnaireUpload);